import React from 'react';
import Summary from "../../common/Summary";

const EmployerSummary = () => {
    return (<Summary ownsClaim={true}
                     nextSteps={[
                         'You\'ll receive an email confirmation from Principal.',
                         'If we need any additional information, we\'ll contact you by email or phone.'
                     ]}/>)
};

export default EmployerSummary;